/** @jsx jsx */
import { Box, jsx } from 'theme-ui';
import Container from '../Grid/Container';
import { getSectionVariant } from './Section.styles';

export default function Section({
  textAlign = undefined,
  background,
  children,
  container = 'fixed',
  ...rest
}) {
  const inner =
    container !== 'none' ? (
      <Container fluid={container === 'fluid'}>{children}</Container>
    ) : (
      children
    );
  const color =
    background && `on${background.replace(/^./, a => a.toUpperCase())}`;
  return (
    <Box
      as="section"
      sx={theme => ({
        ...getSectionVariant(container),
        textAlign,
        backgroundColor: background,
        // Only set the color if it is defined in the theme (so we avoid 'onBlack' colors if they are not defined).
        color: theme && theme.colors && theme.colors[color] && color,
      })}
      {...rest}
    >
      {inner}
    </Box>
  );
}
